<div nz-row>
  <div nz-col nzXs="24" nzSm="24" nzMd="8" nzLg="8" nzXl="8" class="mt-lg pr-lg">
    <nz-card class="offline-card mt-lg">
      <div nz-row class="listStyle" *ngIf="value.type !== 'EXPRESS_COURIER_BL'">
        <div nz-col nzSpan="12">{{value.tgData.referanceType === "DECLARATION" ? ('intelligencemgmt.declarationCode' | translate) : ('intelligencemgmt.manifestNo' | translate)}}</div>
        <div nz-col nzSpan="12">
          {{value.tgData.referenceCode}}
        </div>
      </div>

      <div nz-row class="listStyle" *ngIf="value.type === 'EXPRESS_COURIER_BL'">
        <div nz-col nzSpan="12">{{'intelligencemgmt.manifestNo' | translate}}</div>
        <div nz-col nzSpan="12">
          {{value.tgData.manifestNumber}}
        </div>
      </div>

      <div *ngIf="value.type !== 'EXPRESS_COURIER' && value.type !== 'EXPRESS_COURIER_BL'">
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.regime' | translate}}</div>
          <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("ics-label-regimenCode",value.tgData.regime)}}</div>
        </div>
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.procedure' | translate}}</div>
          <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("umscodes7365",value.tgData.procedure)}}</div>
        </div>
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.mode' | translate}}</div>
          <div nz-col nzSpan="12"
            *ngIf="getRdmDataByRefTypeAndCode('tred8067',value.tgData.modeOfTransport) === 'NA' else showIcon">
            {{'intelligencemgmt.modeNotSpecified' | translate}} </div>
          <ng-template #showIcon>
            <cargoes-business-icons [defaultFormData]="getRdmDataByRefTypeAndCode('tred8067',value.tgData.modeOfTransport)">
            </cargoes-business-icons>
          </ng-template>
        </div>
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.NumberOflines' | translate}}</div>
          <div nz-col nzSpan="12">{{value.tgData.noOfLines}}</div>
        </div>
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.noOfContainers' | translate}}</div>
          <div nz-col nzSpan="12">{{value.tgData.noOfContainers}}</div>
        </div>
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.customoffice' | translate}}</div>
          <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode('ics-customs-office',value.tgData.goodsLocation)}}</div>
        </div>
      </div>

      <div *ngIf="value.type === 'EXPRESS_COURIER' || value.type === 'EXPRESS_COURIER_BL'">
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'ics.manifest.expresscourier.companyName' | translate}}</div>
          <div nz-col nzSpan="12">{{value.type === 'EXPRESS_COURIER' ? value.tgData.importer : value.tgData.blNumber}}</div>
        </div>
      </div>

      <div *ngIf="value.type === 'EXPRESS_COURIER_BL'">
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.houseBlNumber' | translate}}</div>
          <div nz-col nzSpan="12">{{value.tgData.HouseBLNo}}</div>
        </div>
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.transitType' | translate}}</div>
          <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("ics-label-transit-type",value.tgData.TransitType)}}</div>
        </div>
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.expressType' | translate}}</div>
          <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("ics-label-express-type",value.tgData.ExpressType)}}</div>
        </div>
        <!-- <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.loadingPortCode' | translate}}</div>
          <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("ics-label-port-code",value.tgData.LoadingPortCode)}}</div>
        </div>
        <div nz-row class="listStyle">
          <div nz-col nzSpan="12">{{'intelligencemgmt.destinationPort' | translate}}</div>
          <div nz-col nzSpan="12">{{getRdmDataByRefTypeAndCode("ics-label-port-code",value.tgData.LastPortCode)}}</div>
        </div> -->
      </div>
    </nz-card>
  </div>

  <div nz-col nzXs="24" nzSm="24" nzMd="16" nzLg="16" nzXl="16" class="mt-lg pl-lg">
    <div id="risktScore" class="bg-w"></div>
  </div>
</div>
<nz-card class="mt-lg">
  <nz-table #nestedTable [nzData]="value.tData" [nzPageSize]="size" [nzShowPagination]="false" [nzPageIndex]="page">
    <thead>
      <tr>
        <th nzWidth="100px" class="tbl-color1">{{'intelligencemgmt.profileId' | translate}}</th>
        <th nzWidth="100px" class="tbl-color1">{{'ics.intelligencemgmt.riskArea' | translate}}</th>
        <th nzWidth="100px" class="tbl-color1">{{'ics.intelligencemgmt.profileCategory' | translate}}</th>
        <th nzWidth="120px" class="tbl-color1">{{'intelligencemgmt.rule' | translate}}</th>
        <th nzWidth="130px" class="tbl-color1">{{'intelligencemgmt.profileOwner' |translate}}</th>
        <th nzWidth="80px" class="tbl-color1">{{'intelligencemgmt.score' | translate}}</th>
        <th nzWidth="100px" class="tbl-color1">{{'intelligencemgmt.inspectionAction' | translate}}</th>
        <th nzWidth="50px" nzRight="0px" class="tbl-color1" *ngIf="value.type === 'EXPRESS_COURIER'">{{'intelligencemgmt.item' | translate}}</th>
        <th nzWidth="50px" nzRight="0px" class="tbl-color1" *ngIf="value.type !== 'EXPRESS_COURIER' && value.type !== 'EXPRESS_COURIER_BL'">{{'intelligencemgmt.item' | translate}}</th>
        <th nzWidth="130px" class="tbl-color1">{{'intelligencemgmt.recommendedAction' | translate}}</th>
      </tr>
    </thead>
    <tbody class="tbl-color2">
      <ng-template ngFor let-data [ngForOf]="nestedTable.data" let-i="index">
        <tr>
          <td><a (click)="viewDeclaration(data)">{{data.profileCode}}</a></td>
          <td>{{data.trs}}</td>
          <td>{{data.categoryCode}}</td>
          <td>{{data.ruleDetails}}</td>
          <td>{{data.riskRuleOwner}}</td>
          <!-- <td>{{getRdmDataByRefTypeAndCode('ics.risk.area',data.trs)}}</td>
          <td>{{getRdmDataByRefTypeAndCode('ics-risk-factor',data.categoryCode)}}</td>
          <td>{{getRdmDataByRefTypeAndCode('ics-risk-rules',data.ruleDetails)}}</td>
          <td>{{getRdmDataByRefTypeAndCode('ics-label-owner',data.riskRuleOwner)}}</td> -->
          <td>{{data.finalScore}}</td>
          <td> <cargoes-business-icons [defaultFormData]="data?.inspectionCaseAction"></cargoes-business-icons></td>
          <td *ngIf="value.type === 'EXPRESS_COURIER'" nzShowExpand [(nzExpand)]="data.bol" (click)="viewRiskAssManBLProfileEntities(data)"></td>
          <td *ngIf="value.type !== 'EXPRESS_COURIER' && value.type !== 'EXPRESS_COURIER_BL'" nzShowExpand [(nzExpand)]="data.expand"></td>
          <td nzShowExpand [(nzExpand)]="data.rAction"></td>
        </tr>
        <tr [nzExpand]="data.bol" *ngIf="value.type === 'EXPRESS_COURIER'">
          <nz-spin [nzSpinning]="isSpinning" [nzTip]="'intelligencemgmt.screen.loading'|translate">
            <ng-container *ngIf="data.isItemsDisplay && data.expressCourierItems && data.expressCourierItems.length > 0 ">
              <nz-table class="inner-table" #itemsTable [nzData]="data.expressCourierItems" [nzShowPagination]="false">
                <thead>
                  <tr>
                    <!-- <th class="tbl-color3">#</th> -->
                    <th class="tbl-color3">{{'ics.manifest.expresscourier.serial' | translate}}</th>
                    <th class="tbl-color3">{{'ics.manifest.expresscourier.awb' | translate}}</th>
                    <th class="tbl-color3">{{'ics.manifest.expresscourier.origin' | translate}}</th>
                    <th class="tbl-color3">{{'ics.manifest.expresscourier.destination' | translate}}</th>
                    <th class="tbl-color3">{{'ics.manifest.expresscourier.weight' | translate}}</th>
                  </tr>
                </thead>
                <tbody class="tbl-color4">
                  <tr *ngFor="let dt of itemsTable.data; let i = index">
                    <td>{{dt.serial}}</td>
                    <td>{{dt.awb}}</td>
                    <td>{{dt.originCity}}</td>
                    <td>{{dt.destinationCity}}</td>
                    <td>{{dt.weight}} KG</td>
                  </tr>
                </tbody>
              </nz-table>
              <cargoes-pagination-jumper *ngIf="data.expressCourierItems.length >= itemSize" [pageIndex]="data.page || 1" [totalElements]="data.expressCourierItems.length" [pageSize]="itemSize" (onPageIndexChanged)="changePagination($event, data)" 
              class="pagination-jumper"></cargoes-pagination-jumper>
            </ng-container>

            <ng-container *ngIf="data.isItemsDisplay && (!data.expressCourierItems || data.expressCourierItems.length === 0)">
              <div class="text-center">
                <h3>{{'intelligencemgmt.noData' | translate}}</h3>
              </div>
            </ng-container>
          </nz-spin>
        </tr>
        <tr [nzExpand]="data.expand" *ngIf="value.type !== 'EXPRESS_COURIER'">
          <ng-container *ngIf="data.riskAssItemsDetailsList && data.riskAssItemsDetailsList.length > 0 ">
            <nz-table class="inner-table" #innerTable [nzData]="data.riskAssItemsDetailsList" [nzShowPagination]="false">
              <thead>
                <tr>
                  <th class="tbl-color3">#</th>
                  <th class="tbl-color3">{{'intelligencemgmt.sequenceNumber' | translate}}</th>
                  <th class="tbl-color3">{{'intelligencemgmt.hsCode' | translate}}</th>
                  <th class="tbl-color3">{{'intelligencemgmt.score' | translate}}Score</th>
                  <th class="tbl-color3">{{'intelligencemgmt.description' | translate}}</th>
                </tr>
              </thead>
              <tbody class="tbl-color4">
                <tr *ngFor="let data of innerTable.data; let i = index">
                  <td>{{i+1}}</td>
                  <td>{{data?.sequenceNo}}</td>
                  <td>{{data?.comodityCode}}</td>
                  <td>{{data?.score}}</td>
                  <td>{{data?.description}}</td>
                </tr>
              </tbody>
            </nz-table>
          </ng-container>
          <ng-container *ngIf="!data.riskAssItemsDetailsList || data.riskAssItemsDetailsList.length === 0">
            <div class="text-center">
              <h3>{{'intelligencemgmt.noData' | translate}}</h3>
            </div>
          </ng-container>
        </tr>
        <tr [nzExpand]="data.rAction">                
          <ng-container *ngIf="data.recomendedAction">
            <nz-list nzBordered [nzDataSource]="splitRecomndedAction(data.recomendedAction)" nzSize="small" [nzRenderItem]="defaultItem">
              <ng-template #defaultItem let-item>
                <nz-list-item >
                  {{getRdmDesc(item)}}
                </nz-list-item>
              </ng-template>
            </nz-list>
          </ng-container>
          <ng-container *ngIf="data.recomendedActionLabel">
            <nz-list nzBordered [nzDataSource]="splitRecomndedActionLabel(data.recomendedActionDesc[0])" nzSize="small" [nzRenderItem]="defaultItem">
              <ng-template #defaultItem let-item>
                <nz-list-item >
                  {{getRdmDesc(item)}}
                </nz-list-item>
              </ng-template>
            </nz-list>
          </ng-container>
        </tr>
      </ng-template>
    </tbody>
  </nz-table>
  <cargoes-pagination-jumper *ngIf="value.tData.length >= size" [pageIndex]="page" [totalElements]="value.tData.length" [pageSize]="size" (onPageIndexChanged)="page = $event"></cargoes-pagination-jumper>
</nz-card>
